<template>
    <section ref="getRoudReact" id="playCodeToMachine" :class="shit$(`dis:f; z:100; mr:19px; `)">
        <div  @blur="() => mutations.showIs({ showIs: false })"  tabindex="-1" :class="[ shit$(shit.wrapper), shit$(`relative; z:99;`), ]">
            <span
              title="play"
              :class="[ shit$(shit.button), ]"
              @click="() => typeof playButton['to'] === 'function' ? playButton['to']() : this[playButton['to']]()">
              {{ palyAndExcuteStatusText }}
            </span>
            <span v-if="shit.split" :class="[ shit$(shit.split),  ]"></span>
            <span :class="[shit$(shit.icon)]" @click="() => mutations.showIs({ showIs: !store.showIs })">
                <i :class="shit.href"></i>
            </span>

            <el-collapse-transition>
                <div v-show="showIs" :class="shit$(`pb:10px; border: solid 0.5px rgba(168, 168, 172, .7); box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.3); right:0px; radius:15px; w:200px; absolute; font:12px; top:29px; w:100%; bgc:#272727;`)">
                    <p :class="shit$(`letter-s:0.8px; c:#c8c8c8; pl:15px; pt:3px; pb:3px;`)">{{this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_1" ) }}</p>
                    <template v-if="connectGolbalState === 1">
                      <template v-for="(o, i) in playList">
                          <div :key="i" :class="[
                              shit$(`w:99.8%; pl:27px; font:14px; c:#fff; font-w:500; letter-s:0.7px; h:40px; lh:40px; hover:bgc:#444444;`),
                              o.disabled && shit$(`c:#a8a8ac!; hover:bgc:transparent!; cursor:n!;`)
                          ]">
                            <el-checkbox @change="(a, b) => {
                                  if (a) {
                                      playList.forEach(e => e.checked = false)
                                      o.checked = a
                                      mutations.currentChecked({ currentChecked: o.is })
                                      currentPlayList === 'set' && mutations.nosetChecked({ nosetChecked: o.is })
                                  } else {
                                      playList.find(fo => fo.is === 1).checked = true
                                      mutations.currentChecked({ currentChecked: 1 })
                                      currentPlayList === 'set' && mutations.nosetChecked({ nosetChecked: o.is })
                                  }
                              }" v-model="o.checked" :disabled="o.disabled"></el-checkbox>
                              <span :class="[o.disabled && shit$(`c:#696969;`), shit$(`ml:10px;`)]">{{ o.label }}</span>
                          </div>
                          <p :class="shit$(`h:1px; bgc:rgba(168, 168, 172, .7);`)" v-if="!isLastIndex(playList, i)" :key="i + o"></p>
                      </template>
                    </template>
                    <template v-else>
                      <template v-for="(o, i) in playTypeList">
                          <div :key="i" :class="[
                              shit$(`w:99.8%; pl:27px; font:14px; c:#fff; font-w:500; letter-s:0.7px; h:40px; lh:40px; hover:bgc:#444444;`),
                              o.disabled && shit$(`c:#a8a8ac!;  cursor:n!;`)
                          ]">
                            <el-checkbox @change="(a, b) => {
                              if (a) {
                                obserMutations.reset({ key: 'checked', val: false })
                                obserMutations.update({ index: i, val: true, key: 'checked' })
                                obserStateUpdate({ key: 'currentMachine', val: o.tag })
                              } else {
                                obserMutations.update({ index: i, val: true, key: 'checked' })
                              }
                            }" v-model="o.checked" :disabled="o.disabled"></el-checkbox>
                              <span :class="[o.disabled && shit$(`c:#696969;`), shit$(`ml:10px;`)]">{{ o.label }}</span>
                          </div>
                          <p  :class="shit$(`h:1px; bgc:rgba(168, 168, 172, .7);`)" v-if="!isLastIndex(playList, i) " :key="i + o"></p>
                      </template>
                    </template>
                    <p v-if="!connectGolbalState" :class="shit$(`w:160px; h:auto; m:auto; mt:4px; lh:normal; font:12px; font-w:500; letter-s:0.6px; c:#a8a8ac; cursor:d;`)">{{this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_25" ) }}～</p>
                </div>
            </el-collapse-transition>
        </div>
        
        <T-dialog v-if="playButton['is']" @dialogClose="done => { done(), Object.assign(this.dialogInfo, { isShow: false }) }" :dialog="dialogInfo" >
            <div slot="content" :class="shit$(`h:450px; bgc:#fff; radius:10px;`)">
                <img :class="shit$(`mxw:450px; h:100%; bblr:10px; btlr:10px;`)" :src="`${env$}static/images/public-code-lab.png`" />
                <section :class="shit$(`font-w:500; mxw:266px; lh:normal; absolute; top:36px; right:39px;`)">
                    <div :class="shit$(`font:24px; letter-s:1.37px; c:#00b5e2; mb:10px;`)">
                        <p>{{this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_4" ) }}，</p>
                        <p>{{this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_5" ) }}！</p>
                    </div>
                    <div :class="shit$(`c:#272727; font:18px; letter-s:1.03px; lh:1.5;`)">
                        <p>{{this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_6" ) }}～</p>
                        <p>{{this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_7" ) }}，{{this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_8" ) }}～</p>
                    </div>
                </section>
                <div :class="shit$(`font:16px; font-w:500; letter-s:1.07px; w:190px; absolute; right:77px; bottom:30px;`)">
                    <el-button :class="shit$(`p:0px; w:100%; radius:10px; bgc:#00b5e2!; c:#fff!; border:none; hover:opacity:0.6; active:opacity:1;`)">
                        <a :class="shit$(`dis:b; h:45px; lh:45px; font:16px!; font-w:500; letter-s:1.07px; c:#fff;`)" :href="util$.getNuwaWebsite()" target="_blank">{{this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_9" ) }}</a>
                    </el-button>
                    <a :class="shit$(`dis:b; c:#00b5e2; text-a:c; h:24px; lh:24px; cursor:p; mt:10px;`)" href="https://www.nuwarobotics.com/" target="_blank">{{this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_10" ) }}</a>
                </div> 
            </div>
        </T-dialog>
        <T-dialog  @dialogClose="done => {  done() }" :dialog="dialogInfoExcute">
          <div slot="content">
              <div :class="shit$(`m:auto; c:#fff; mb:25px; text-a:c; w:300px; lh:1.57; font:14px; font-w:500; lh:1.57; letter-s:1px;`)">
                <img :class="shit$(`height:150px;`)" :src="`${env$}static/images/excute_to_robot_failed.png`" />
                <p :class="shit$(`text-a:l; mt:25px;`)">{{ $t('command_transmission_test_text.text_1') }} {{ num$ }} {{ $t('command_transmission_test_text.text_2') }}...</p>
              </div>
              <div :class="shit$(`justify-c:sb; dis:f;`)">
                <el-button @click="handleExcuteError(0)" :class="shit$(`p:0px; w:160px; radius:32.5px; bgc:#727272!; c:#333!; border:none; hover:opacity:0.6; active:opacity:1;`)">
                  <span :class="shit$(`dis:b; h:48px; lh:48px; font:16px!; font-w:500; letter-s:1.07px; c:#fff;`)" >{{ $t('command_transmission_test_text.text_3') }}</span>
                </el-button>  
                 <el-button @click="handleExcuteError(1)" :class="[ shit$(`p:0px; w:160px; radius:32.5px; bgc:${ numTimer ? 'rgba(31,31,31,0.5)' : '#00b5e2' }!; border:none; hover:opacity:0.6; active:opacity:1; ${ numTimer && 'cursor:not-allowed!;' }`) ]">
                    <span :class="shit$(`dis:b; h:48px; lh:48px; font:16px!; font-w:500; letter-s:1.07px; c:${ numTimer ? '#696969' : '#fff' };`)" >{{ $t('command_transmission_test_text.text_4') }}</span>
                  </el-button>
              </div>
          </div>
        </T-dialog>
    </section>
</template>

<script>
import { mapState } from "vuex";
import saveProjectMix from "@/code-lab/component/mixins/save-project-mix.js";
import TDialog from "@/code-lab/view/organization/s-dialog.vue";
import { store, mutations } from "@/code-lab/component/robot-connect/play-button/observable.js";
import { store as robotConnectStore, mutations as robotConnectMutations } from "@/code-lab/component/robot-connect/robotConnectOber.js";
import { store as deviceMangeStore } from "@/code-lab/component/robot-connect/device-manage/observable/store.js";

import connectRequestMix from "@/code-lab/component/connection/connect-request-mix.js";
import mixFileRequestManage from '@/code-lab/component/file-management/mixins/mix-file-request-manage.js'
import { obserState, obserMutations } from '@/code-lab/component/robot-connect/play-button/microstate/checkBox.js'
import { obserState as obserStatePlay, update as obserStateUpdate } from '@/code-lab/component/robot-connect/play-button/microstate/playState.js'
import { RobotHanlde } from '@/service/toolClass.js'
import { mutations as exchangeutations } from '@/code-lab/component/exchange/observable.js'
import beforeCloseConnectMix from '@/code-lab/component/robot-connect/play-button/before-close-connect.js'

import IndexMixGroceryStore from "@/code-lab/component/mixins/indexMixStore.js";
import YoutubeHandler from '@/service/tool/youtubeHandler.js'
const Cookies = window.Cookies;
export default {
  mixins: [ saveProjectMix, connectRequestMix, mixFileRequestManage, beforeCloseConnectMix, IndexMixGroceryStore ],
  components: { "T-dialog": TDialog },
  data () {
    return {
      pressIs: false,
      dialogInfo: {
        isShow: false,
        width: "800px",
        closeOnModal: false,
        closeOnEscape: false,
        appendToBody: true,
        class: "playCodeToMachineDialog"
      },
      dialogInfoExcute: {
        title: this.$t('command_transmission_test_text.text_5'),
        isShow: false,
        width: '400px',
        appendToBody: true,
        showClose: false,
        class: 'robot_excute_error',
        closeOnModal: false,
        closeOnEscape: false,
      },
      playMachineTime: null,
      startPlayOnQuickFlg: false,
      stopPlayOnQuickFlg: false,
      isAllowToStopRobot: false,
      loadingIs: false,
      playMachineTimeTask: null,
      excuteProgressStatus: '',
      num$: 30,
      numTimer: null,
      install_progress: 0,
      quickRobotDownloadProcessMsg: null,
      excuteProgressMp: { add: this.$t('command_transmission_test_text.text_6'), edit: this.$t('command_transmission_test_text.text_7'), export_false: this.$t('command_transmission_test_text.text_8'), export: this.$t('command_transmission_test_text.text_9'), excute_true: this.$t('command_transmission_test_text.text_10'), excute_false: this.$t('command_transmission_test_text.text_11'), install_response_true: this.$t('command_transmission_test_text.text_12'), install_response_false: this.$t('command_transmission_test_text.text_13'), start_block: this.$t('command_transmission_test_text.text_14'), install_progress: this.$t('command_transmission_test_text.text_15') }
    };
  },
  beforeCreate() {
    this.mutations = mutations;
    this.store = store;
    this.obserMutations = obserMutations
    this.obserStateUpdate = obserStateUpdate
  },
  created () {
    if (this.currentVersion !== "teacher") {
      if (this.currentVersion === "public") {
        
        deviceMangeStore.commit("button/connectButtonStatus", {
          connectButtonStatus: "public.normal"
        });
        deviceMangeStore.commit("button/current", { current: 3 });
      } else {
        deviceMangeStore.commit("button/connectButtonStatus", {
          connectButtonStatus: "connect.quickNormal"
        });
        deviceMangeStore.commit("button/current", { current: 2 });
      }
    }
  },
  mounted () {
    const langCode = Cookies.get("langCode");
    this.$store.commit('introStore/updSimulatorDB', [{
      stack: [ { index: 0, md: 'top', target: this.$refs.getRoudReact, position: 'top', type: 'rect_', clientH: 500, clientW: 400, offsetRct: 15 , data: {
            header_t1: this.$t("code-lab/component/robot-connect/play-button/play-on-robot.vue_20"),
            header_t2: this.$t("code-lab/component/robot-connect/play-button/play-on-robot.vue_21"),
            img: `${this.env$}static/images/intro/${langCode}/intro_1.png`,
            content_t1: this.$t("code-lab/component/robot-connect/play-button/play-on-robot.vue_22"),
            btn_t1: this.$t("code-lab/component/robot-connect/play-button/play-on-robot.vue_23"),
            btn_t1_shit: 'bottom:30px!;'
        }}
      ]
    }])
  },
  watch: {
    deviceManageButtonClickData(n) {
      if (n && this.isPublic()) {
        deviceMangeStore.commit('button/clickData', { clickData: false })
        window.open(this.util$.getNuwaWebsite());
      }
    },
    showIs (val) {
      if (this.connectGolbalState === 1) {
        val ? mutations.currentShit({ currentShit: "connected.select/1.shit" }) : mutations.currentShit({ currentShit: "connected.normal.shit" })
      } else if (this.noGetSimulatorKey && this.currentVersion === 'family') {
        val ? mutations.currentShit({ currentShit: "noGetSimulatorKey.select/1.shit" }) : mutations.currentShit({ currentShit: "noGetSimulatorKey.normal.shit" })
      } else if (this.connectGolbalState === 2) {
        val ? mutations.currentShit({ currentShit: "quickConnected.select/1.shit" }) : mutations.currentShit({ currentShit: "quickConnected.normal.shit" })
      } else {
        val ? mutations.currentShit({ currentShit: "noConnect.select/1.shit" }) : mutations.currentShit({ currentShit: "noConnect.normal.shit" });
      }
    },
    async currentChecked(val) {
      console.log('currentChecked -0>', val)
      if (!val) return;
      if (val === 4) this.$store.commit("setDevicePlay/switchRmsHandler", true);
      const deviceCurrent = deviceMangeStore.state.pop.stopCode;
      const playCurrent = robotConnectStore.play[val];

      if (deviceCurrent && playCurrent) {
        const fns = robotConnectStore.play.map[  playCurrent + "/" + robotConnectStore.stop[deviceCurrent] ];
        fns.forEach(fn => deviceMangeStore.commit("pop/" + fn));
      }
      robotConnectMutations.playValue(val);
      robotConnectMutations.stopValue(deviceCurrent);
    },
    connectGolbalState(val) {
      if (!val) {
        if (this.loadingIs) {
          if (this.playMachineTimeTask) {
            clearTimeout(this.playMachineTimeTask)
            this.playMachineTimeTask = null
          }
          if (this.numTimer) {
            clearInterval(this.numTimer)
            this.numTimer = null
          }
          this.handleExcuteError()
        }
        mutations.currentPlayList({ currentPlayList: "normalSet" });
        mutations.currentShit({ currentShit: "noConnect.normal.shit" });
        mutations.showIs({ showIs: false });
        if (robotConnectStore.mapping.receive.play[this.playValue] !== "set") this.$store.commit("setDevicePlay/HANDLECONNECTDEVICES", []); 
        mutations.status({ status: 1 })
        this.buttonLock = false
        if (this.noGetSimulatorKey && this.currentVersion === 'family') {
          this.obserMutations.update({ tag: 1, val: true, key: 'disabled' })
          this.obserMutations.update({ tag: 1, val: false, key: 'checked' })
        } else {
          this.reset()
        }
        this.obserStateUpdate({ key: 'currentMachine', val: 0 })
      } else if (val === 1) {
        mutations.currentShit({ currentShit: "connected.normal.shit" });
        const startReceive = robotConnectStore.mapping.receive.play[this.playValue];
        const stopReceive = robotConnectStore.mapping.receive.stop[this.stopValue];
        const stopVice = robotConnectStore.mapping.voice.stop[this.stopVoiceValue];
        if (startReceive === "set") return
        startReceive && this.startReceive(startReceive);
        stopReceive && this.stopReceive(stopReceive);
        stopVice ? this.stopVoice(stopVice) : this.startVoice();
      } else if (val === 2) {
        mutations.currentPlayList({ currentPlayList: "quickSet" });
        this.obserMutations.update({ tag: 1, val: false, key: 'disabled' })
        if (this.noGetSimulatorKey && this.currentVersion === 'family') {
          this.obserMutations.update({ tag: 1, val: true, key: 'checked' })
          this.obserStateUpdate({ key: 'currentMachine', val: 1 })
        } else {
          mutations.currentShit({ currentShit: "quickConnected.normal.shit" });
        }
      }
    },
    teachConnectDevices(val) {
      if (!val.length) return mutations.currentPlayList({ currentPlayList: "set" });
      mutations.currentPlayList({ currentPlayList: "seted" });
    },
    playValue(newVal) {
      if (newVal === 4) return
      const to = robotConnectStore.mapping.receive.play[newVal];
      this.startReceive(to);
    },
    stopValue(newVal) {
      const to = robotConnectStore.mapping.receive.stop[newVal];
      this.stopReceive(to);
    },
    stopVoiceValue(newVal) {
      const to = robotConnectStore.mapping.voice.stop[newVal];
      to ? this.stopVoice(to) : this.startVoice();
    },
    statusPlayButton (n) {
      if (n === 3) {
        obserStateUpdate({ key: 'buttonLock', val: false })

        mutations.status({ status: 1 })
        if ( this.connectGolbalState ) {
          if (this.stopOr) {
            return
          }
          this.stopPlayOnQuick()
        }
      }
    },
    currentMachine (value) {
      obserStateUpdate({ key: 'buttonLock', val: false })
      // this.buttonLock = false
      if (value === 0) {
        mutations.status({ status: 0 })
        if (this.startPlayOnQuickFlg && this.isAllowToStopRobot) {
          if (this.stopOr) {
            return
          }
          this.stopPlayOnQuick()
        } else if (this.startPlayOnQuickFlg) {
          this.stopPlayOnQuickFlg = true
        }
      } else if (value === 1) console.log("stop simulator")
    },
    noGetSimulatorKey: {
      immediate: true,
      handler (nv) {
        if (!nv) {
          if (this.connectGolbalState === 2) {
            this.obserMutations.hdCurrent("playTypeList")
            this.reset(1)
            this.obserMutations.update({ tag: 0, val: false, key: 'disabled' })
            this.obserStateUpdate({ key: 'currentMachine', val: 1 })
          }
          return
        }
        
      }
    }
  },
  computed: {
    palyAndExcuteStatusText () {
      const { statusPlayButton, simulatorState, loadingIs } = this
      if (loadingIs) {
        return this.$t('command_transmission_test_text.text_16') + '...'
      }
      return statusPlayButton === 2 || simulatorState === 2 ? this.$t("code-lab/component/robot-connect/play-button/play-on-robot.vue_0") : this.currentCheckedPrefixText
    },
    ...mapState('user', [
        'teamId',
        'token'
    ]),
    ...mapState({
      env$: "env$",
      workSpace: "workSpace",
      projectData: "projectData",
      isAllowSave: "isAllowSave",
      currentVersion: "currentVersion",
      currentMission: "currentMission",
      connectGolbalState: "connectGolbalState",
      simulatorInitStatus: 'simulatorInitStatus'
    }),
    ...mapState("teachConnection", { teachConnectDevices: "connectDevices" }),
    ...mapState("setDevicePlay", { setPlayConnectDevices: "connectDevices" }),
    noGetSimulatorKey () { return exchangeutations.isEmpty('simulator') },
    currentShitState () {
      return store.currentShit
    },
    playTypeList () {
      return obserState[obserState.current]
    },
    playList() {
      return store[store.currentPlayList].playList;
    },
    currentPlayList() {
      return store.currentPlayList;
    },
    playButton() {
      return this.computedPlayButton();
    },
    currentChecked() {
      console.log('currentChecked -0> cpt', store.currentChecked,
        exchangeutations.isEmpty ('simulator')
      )
      return store.currentChecked;
    },
    currentCheckedPrefixText () {
      console.log(this.currentChecked, 'currentChecked')
      if (exchangeutations.isEmpty ('simulator')) {
        return this.$t("LANG_BTN_TEXT_EXECUTE")
      }
      return this.currentMachine === 0 ? this.$t('playButtoTextContent.machine') : this.$t('playButtoTextContent.robot')
    },
    showIs() {
      return store.showIs;
    },
    statusPlayButton () {
      return store.status
    },
    shit() {
      const current = store.currentShit;
      if (current.indexOf(".") > -1) return current.split(".").reduce((a, b) => a[b], store)
      return store[current];
    },
    playValue() {
      return robotConnectStore.playValue;
    },
    stopValue() {
      return robotConnectStore.stopValue;
    },
    stopVoiceValue() {
      return deviceMangeStore.state.pop.stopVoice;
    },
    deviceManageButtonClickData() {
      return deviceMangeStore.state.button.clickData;
    },
    simulatorState () {
      return obserStatePlay.simulator
    },
    currentMachine () {
      return obserStatePlay.currentMachine
    },
    inProgressIs () {
      return obserStatePlay.inProgressIs
    },
    simulatorIs () { return exchangeutations.isEmpty('simulator') },
  },
  methods: {
    handleExcuteError (tag) {
        // this.resetPlayStatus()
        if (!tag) {
          this.dialogInfoExcute.isShow = false
          if (this.numTimer) {
            clearInterval(this.numTimer)
            this.numTimer = null
          }
          this.num$ = 30
          this.loadingIs = false
        } else {
          if (this.numTimer) return
          this.dialogInfoExcute.isShow = false
          this.loadingIs = false
          this.num$ = 30
          this.runCodeToMachine()
        }
    },
    reset (tag = 0) {
      this.obserMutations.reset({ key: 'checked', val: false })
      this.obserMutations.reset({ key: 'disabled', val: true })
      this.obserMutations.update({ tag, val: true, key: 'checked' })
      this.obserMutations.update({ tag, val: false, key: 'disabled' })
    },
    resetPlayStatus () {
      obserStateUpdate({ key: 'stopOr', val: false })
      this.startPlayOnQuickFlg = false
      this.stopPlayOnQuickFlg = false
      this.isAllowToStopRobot = false
      obserStateUpdate({ key: 'buttonLock', val: false })
      mutations.status({ status: 0 })
    },
    async stopPlayOnQuick () {
      obserStateUpdate({ key: 'stopOr', val: true })
      this.b$.catchCallBack('quick', 'ws.cmd.update_robot_code_lab_stop', () => {
        this._updInProgressIs(0)
        this.$message({ type: "success", message: this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_12" ), duration: 5000, customClass: "socketErrorCodeClass_g" })
      })
      await new RobotHanlde().set_code_execute('quick', this.b$)
      .then(() => {
        this.$message({ type: "success", message: this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_14" ), duration: 3000, customClass: "socketErrorCodeClass_g" })
      })
    },
    isPublic() {
      return this.currentVersion === "public";
    },
    startVoice(to = "all") {
      if (to) {
        this.set_start_voice({ to });
      }
    },
    stopVoice(to) {
      if (to) {
        this.set_stop_voice({ to });
      }
    },
    startReceive(to) {
      if (to) {
        this.set_start_receive({ to });
      }
    },
    stopReceive(to) {
      if (to) {
        this.set_stop_receive({ to });
      }
    },
    isLastIndex(arr, index) {
      return arr.length - 1 === index;
    },
    computedPlayButton() {
      const mapping = {
        public: { is: true, to: "runCodeToMachine" }, 
        student: { is: false, to: "runCodeToMachine" },
        family: { is: false, to: "runCodeToMachine" },
        teacher: { is: false, to: "runCodeToMachine" }
      };
      return mapping[this.currentVersion];
    },
    canPlayOn() {
      return this.connectGolbalState && this.isAllowSave;
    },
    async runCodeToMachine() {
      const connectState = this.connectGolbalState;
      if (!this.simulatorInitStatus && !this.simulatorIs && this.currentMachine === 0){
        return console.error('simulator init fialed');
      } 
      mutations.showIs({ showIs: false });

      if (this.playMachineTime) {
        clearTimeout(this.playMachineTime)
        this.playMachineTime = null
        console.log('正在实行 playMachineTime -> 1')
      }
      delete window.performingPlaybackTasks
      this.startPlayOnQuickFlg = true
      if ( this.statusPlayButton !== 2 ) {
        if (!this.isAllowSave) return console.error("not allow save!");
      }

      if (this.loadingIs) return

      if (![0, 3].includes(this.inProgressIs)) return

      if ( this.currentMachine === 0 ) {
        if (!this.buttonLock) {
          return this.playOnSimulator()
        }
      }

      if (connectState) {
        if (this.buttonLock) return
        obserStateUpdate({ key: 'buttonLock', val: true })
      }

      if ( this.statusPlayButton === 2 ) return mutations.status({ status: 3 })
      
      if (this.currentMachine === 0 || this.statusPlayButton === 3) return this.playMachineTime = setTimeout(async () => {
        console.log('正在实行 playOnRobot')
        await this.playOnRobot()
      }, 1000)
      this.loadingIs = true
      this.setTimeoutForPlay()
      this.playMachineTime = setTimeout(async () => {
        const result = await this.playOnRobot()
        console.log(result, '正在实行')
        if (this.playMachineTimeTask) {
          clearTimeout(this.playMachineTimeTask)
          this.playMachineTimeTask = null
        }
        if (result) {
          setTimeout(() => this.loadingIs = false, 300)
        } else {
          this.baseExcuteError()
          // setTimeout(() => this.loadingIs = false, 300)
        }
        console.log(result)
      }, 1000)
    },
    baseExcuteError () {
      if (this.numTimer) {
        clearInterval(this.numTimer)
        this.numTimer = null
        if (!this.connectGolbalState) return console.error('连接已关闭')
      }
      // if (this.  numTimer) return console.log('正在实行 not baseExcuteError')
      console.log('正在实行 baseExcuteError', this.num$)
      window.performingPlaybackTasks = true
      setTimeout(() => this.dialogInfoExcute.isShow = true, 800)
      this.numTimer = setInterval(() => {
        console.log('正在实行 baseExcuteError num', this.num$)
        if (this.num$ <= 0) {
          if (this.numTimer) {
            clearInterval(this.numTimer)
            this.numTimer = null
          }
          return
        }
        this.num$--
      }, 1000)
      this._updInProgressIs(0)
      this.startPlayOnQuickFlg = false
      obserStateUpdate({ key: 'buttonLock', val: false })
      mutations.status({ status: 1 })
    },
    async palyOnRms(url) {
      if (!url) return console.error("no executeUrl!");
      await this.b$.send( "rms", { cmd: "set_code_execute", data: { url } },
        response => {
          this.$message({
            message: this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_15" ),
            type: "success",
            customClass: "socketErrorCodeClass_g"
          });
          return Promise.resolve(response);
        }
      );
    },
    async playOnQuick(url, cb) {
      try {
        const { serialNumber, to } = this.b$.quick.store;
        if (!url) return console.error("no saveToRobotUrl!");
        this._updInProgressIs(2)
        return new Promise((resolve) => {
          cb('excute_true')
          this.b$.send( "quick", {
            cmd: "set_code_execute",
            data: {
              destinationName: this.projectData.name || this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_16" ), 
              from: serialNumber,
              size: 0,
              url,
              to
            }
          }, response => {
            if (response.cmd === "code_install_response" && response.data) {
              if (typeof response.data.result !== 'boolean') return console.error("must a boolean")
              if (response.data.result) {
                cb('install_response_true')
                if (window.performingPlaybackTasks) return resolve ()
                this.$message({
                  message: this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_17" ),
                  type: "success",
                  customClass: "socketErrorCodeClass_g"
                });
              } else if (!response.data.result) {
                cb('install_response_false')
                if (window.performingPlaybackTasks) return resolve ()
                this._updInProgressIs(0)
                this.startPlayOnQuickFlg = false
                obserStateUpdate({ key: 'buttonLock', val: false })
                mutations.status({ status: 1 })
                this.$message({
                  message: this.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_18" ),
                  type: "error",
                  customClass: "socketErrorCodeClass_g"
                });
                resolve(0)
              }
            } else if (response.cmd === "start_block") {
              cb('start_block')
              if (window.performingPlaybackTasks) return resolve ()
              this._updInProgressIs(3)
              obserStateUpdate({ key: 'buttonLock', val: false })
              this.isAllowToStopRobot = true
              mutations.status({ status: 2 })
              this.$message({
                message: this.$t("code-lab/component/robot-connect/play-button/play-on-robot.vue_24"),
                type: "success",
                customClass: "socketErrorCodeClass_g"
              })
              resolve(1)
            } else if (response.cmd === "code_install_progress" && response.data) {
                cb('install_progress')
                if (window.performingPlaybackTasks) return resolve ()
                this.install_progress = response.data.progress + '%'
            }
          }
        );
        })
      } catch (err) {
        cb('excute_false')
        this._updInProgressIs(0)
        this.startPlayOnQuickFlg = false
        obserStateUpdate({ key: 'buttonLock', val: false })
        mutations.status({ status: 1 })
        return 0
      }

    },
    playOnSimulator () {
      try {
        if (YoutubeHandler.cosntVar.inited && YoutubeHandler.cosntVar.screenEvent && YoutubeHandler.cosntVar.screenIframe) {
            console.log(YoutubeHandler)
            // debugger
            YoutubeHandler.cosntVar.screenEvent.target.mute()
            // YoutubeHandler.cosntVar.screenEvent.target.f.style['pointer-events'] = 'none'
            YoutubeHandler.cosntVar.screenIframe.style['pointer-events'] = 'none'
            YoutubeHandler.cosntVar.robotEvent.target.playVideo()
            YoutubeHandler.cosntVar.screenEvent.target.playVideo()
            YoutubeHandler.cosntVar.robotEvent.target.stopVideo()
            YoutubeHandler.cosntVar.screenEvent.target.stopVideo()
            window.ytPlayCallBack$$ = (ytVideoId = 'Vbks4abvLEw') => {
              document.getElementById('youtubeIframeRobotContainerId').style.display = 'block'
              document.getElementById('youtubeScreenIframeWrapperId').style.display = 'block'
              YoutubeHandler.cosntVar.robotEvent.target.loadVideoById(ytVideoId)
              YoutubeHandler.cosntVar.screenEvent.target.loadVideoById(ytVideoId)
            }
            window.robotEvent$ = YoutubeHandler.cosntVar.robotEvent
            window.screenEvent$ = YoutubeHandler.cosntVar.screenEvent
        }
        window.youtubeInited = YoutubeHandler.cosntVar.inited
      } catch (err) {
        console.log(err, "youtube error:")
      }

      obserStateUpdate({ key: 'simulator', val: 1 })
    },
    setTimeoutForPlay () {
      if (this.playMachineTimeTask) {
        clearTimeout(this.playMachineTimeTask)
        this.playMachineTimeTask = null
      }
      this.playMachineTimeTask = setTimeout(() => {
          this.baseExcuteError()
      }, 60000)
    },
    async playOnRobot() {
      console.log('正在实行 playOnRobot -> ')
      const connectState = this.connectGolbalState;
      const mapping = { 1: "palyOnRms", 2: "playOnQuick" }
      this._updInProgressIs(1)
      const result = await this.saveProjectAndExportExecuteUrl(Object.assign({}, this.currentMission ? { name: this.projectData.name, missionId: this.currentMission.missionId } : { name: this.projectData.name }), undefined, undefined, rst => {
        console.log(this.excuteProgressStatus)
        if (this.loadingIs) {
          this.excuteProgressStatus = rst
          this.setTimeoutForPlay()
        }
        console.log('正在实行 ->', rst, this.loadingIs)
      });
      if (!result || window.performingPlaybackTasks) return false
      this.$store.commit("UPDATE_IS_SAVED", true);
      return await this.export_project(this[mapping[connectState]], rst => {
        if (this.loadingIs) {
          this.excuteProgressStatus = rst
          this.setTimeoutForPlay()
        }
        console.log('正在实行 ->', rst, this.loadingIs)
      });
    },
    export_project (fn, cb) {
      const { projectId } = this.projectData;
      if (!projectId) return console.error("not found projectId");
      return new Promise(resolve => {
        cb && cb('export')
        this.b$.send( "tool", { cmd: "export_execute_file", data: { projectId } }, async letter => {
          if (!["done", "task_creating", "task_created", "task_finished", 'todo'].includes(letter.data.state)) {
            this._updInProgressIs(0)
            cb('export_false')
            return resolve()
          }
          if (letter.data.state === "task_finished") {
            const result = fn && await fn(letter.data.url + `?customerId=${this.teamId}&token=${this.token}`, cb)
            if (window.performingPlaybackTasks) return resolve ()
            resolve(result)
          }
        })
      })
    }
  },
}
</script>

<style lang="scss">
.playCodeToMachineDialog {
  
    max-width: 800px;
    background: transparent;
    border-radius: 10px;
  
  .el-dialog--center .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__header {
    padding: 0px;
  }
}
#playCodeToMachine {
  display: flex;
  align-items: center;
  font-size: 12px;
  .el-loading-mask {
    background-color: transparent;
    .el-loading-spinner {
      margin-top: 0px;
      margin-left: 2px;
      top: 0;
      .circular {
        height: 20px;
        width: 20px;
      }
      .path {
        stroke-width: 4px;
        stroke: #00b5e2;
      }
    }
  }
  .el-checkbox__inner:hover {
    border-color: #0ed3ff;
  }
  .el-checkbox__inner {
    border-color: #a8a8ac;
    background-color: transparent;
  }
  .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: transparent !important;
    
    border-color: #a8a8ac !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #0ed3ff !important;
    background-color: transparent !important;
  }
  .el-checkbox__inner::after {
    border-color: #0ed3ff !important;
  }


}
.robot_excute_error {
  background-color: #444444;
  border-radius: 24px;
  .el-dialog__header {
    height: 60px;
    line-height: 50%;
    background: #333;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    .el-dialog__title {
      color: #ffffff;
    }
  }
  .el-dialog--center .el-dialog__body {
    padding: 25px 30px 30px;
  }
}
</style>
